import { Fragment, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Column } from 'react-table';

import { LayoutGestaoLeads } from '../components/LayoutGestaoLeads';
import TableStatusLeads from '../components/TableStatusLeads';

export const ListaLeads = () => {
  return (
    <LayoutGestaoLeads>
      <div className="tw-h-[80vh]">
        <TableStatusLeads header={'Acompanhamento de leads'} />
      </div>
    </LayoutGestaoLeads>
  );
};
